const getPublishedListingUrl = category => category && category.publishedListingPage && category.publishedListingPage.url;
export default getPublishedListingUrl;
//# sourceMappingURL=get-published-listing-url.js.map